import {  Layout } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import { Card,  CardBody, CardHeader, Row, Col } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux';
import { getSchools } from '../../actions/school';
import { useParams } from 'react-router-dom';
import Headers from './Headers';
import { axiosConfig, SERVER_PATH } from '../../actions/common';
import axios from 'axios';
import Bar from './Bar'
import BarTerm from './BarTerm'


const { Content } = Layout;

export default function Menus(props) {

  const {reportid} = useParams()
  const [arrreports, setarrreports] = useState({})
  const [rep, setrep] = useState([1])
  const [maindatax, setmaindatax] = useState({})
  const dispatch = useDispatch()
  const userSelector = useSelector(state=>state.userReducer)
  const {user, mid, schoolId} = userSelector
  const repid = reportid / ( 2 * 13 * 13 * 13 *13)
  const reportSelector = useSelector(state=>state.reportReducer)
  const {reports, schools, sessions, terms, claszs:claszs1} = reportSelector

  const [loadingData, setloadingData] = useState(false)
  const avg = (sumz)=>{
    if(sumz !== undefined && Array.isArray(sumz) && sumz.length > 0)
    {
        let sums = sumz.reduce((a, b)=>parseFloat(a) + parseFloat(b), 0);
        return Number(sums/sumz.length).toFixed(1)}
} 

  useEffect(() => {
    if(schoolId > 0){
      let params = {
        data:JSON.stringify(
        {
          'id': schoolId
        }),
        cat:'selected_school',
        table:'schools',
        narration:'get school'
      }
      dispatch(getSchools(params))
    }
  }, [user])

  useEffect(() => {
    let vals = []
    Object.keys(reports).forEach(schoolid=>{
        let sessions = reports[schoolid]
        Object.keys(sessions).forEach(sessionid=>{
            let terms = sessions[sessionid]
            Object.keys(terms).forEach(termid=>{
                let claszs = terms[termid]
                Object.keys(claszs).forEach(claszid=>{
                    let reps = claszs[claszid]
                    Object.keys(reps).forEach(repidx =>{
                      vals.push(repidx)
                    })
                })
            })              
        })
    })
    setrep(vals)
  }, [reports])

  useEffect(() => {
      if(rep.length > 0)
      {
        setloadingData(true)
        let params = {
            data:JSON.stringify({
                    'studentid': mid,
                    'reports':rep.join(','),
            }),
            cat:'selected_analysis',
            table:'notes',
            narration:'get subjects'
        }
        axios.get(SERVER_PATH, {params}, axiosConfig)
        .then(res =>{
           let  r = res.data
            setmaindatax(r)
            setloadingData(false)
        })
        .catch(err=>{
            console.log(err)
            setloadingData(false)
        })
      }
}, [mid, rep])

let sum_exam = {}
let sum_subject = {}
let sum_report = {}
let all_subject = {}
let all_report = {}

if(Array.isArray(Object.keys(maindatax))){
Object.keys(maindatax).forEach(element => {
    let d = maindatax[element]
    
    d.forEach(data => {
        let {score, subjectid, subjectname, reportname, reportid} = data || ''
        //total array
        if(sum_exam.hasOwnProperty(reportid)){
            sum_exam[reportid].push(parseFloat(score))
        }else{
            sum_exam[reportid] = []
            sum_exam[reportid].push(parseFloat(score))
        }
        //subject array
        if(sum_subject.hasOwnProperty(subjectid)){
            sum_subject[subjectid][reportid] = parseFloat(score)
        }else{
            sum_subject[subjectid] = {}
            sum_subject[subjectid][reportid] = parseFloat(score)
        }

         //subject array
         if(sum_report.hasOwnProperty(reportid)){
            sum_report[reportid][subjectid] = parseFloat(score)
        }else{
            sum_report[reportid] = {}
            sum_report[reportid][subjectid] = parseFloat(score)
        }
        //all reports
        all_subject[subjectid] = subjectname
        all_report[reportid] = reportname
    });
});
}
let sum_exam_avg = {}
Object.keys(sum_exam).forEach(element => {
    let v = avg(sum_exam[element])
    sum_exam_avg[element] = Number(v).toFixed(1)
});

  return (
    <Layout className="site-layout" style={{minHeight:'800px'}}>
        <Headers />
     <Content className="site-layout text-left" style={{ margin: '0 5rem', marginTop: 30 }}>
       <Row style={{minHeight:'200px'}}>
           <Col xs={12}>
               <BarTerm
                title={'Averages'}
                subtitle="" 
                subjects={all_subject}
                reports={all_report}
                data ={sum_exam_avg}
                />
           </Col>
           <Col>
           <h1>Analysis</h1>
           <table>
               <thead>

               </thead>
               <tbody>

               </tbody>
           </table>
           </Col>
       </Row>
       <Row xs="12">
           <Col xs={12}>
           {
               Object.keys(all_report).map(rw=>{
                   return  <Card>
                       <CardHeader>
                           {all_report[rw]}
                       </CardHeader>
                       <CardBody>
                           <p>
                            <Bar 
                                title={all_report[rw]}
                                subtitle="-" 
                                subjects={all_subject}
                                reports={all_subject}
                                data ={sum_report[rw] || {}}
                            />
                            </p>
                       </CardBody>
                   </Card>
               })
           }
           </Col>
       </Row>
       <Row xs="12">
           {
               Object.keys(all_subject).map(rw=>{
                   return <Col key={rw} style={{minHeight:"200px"}} xs="12" sm={6} md="4">
                   <Card>
                       <CardHeader>
                           <h3>{all_subject[rw]}</h3>
                       </CardHeader>
                       <CardBody>
                           <p>
                            <Bar 
                                title={all_subject[rw]}
                                subtitle="" 
                                subjects={all_subject}
                                reports={all_report}
                                data ={sum_subject[rw] || {}}
                            />
                            </p>
                       </CardBody>
                   </Card>
                   </Col>
               })
           }
       </Row>
    </Content>
    </Layout>
  )
}
